import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import styles from './index.css';
import { rel as relText } from '../../../utils/rel';
import { classNames } from '../../../utils/classnames';

class Nav1 extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    navListView(list = []) {
        return list.map((item, index) => {
            return (
                <a key={index} href={item.url} target="_blank" rel={relText}>
                    {item.title}
                </a>
            );
        });
    }
    render() {
        return <div className={classNames(styles.nav1, 'clearfix')}>{this.navListView(this.props.content)}</div>;
    }
}

class Nav2 extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    navListView(list = []) {
        return list.map((item, index) => {
            return (
                <li key={index}>
                    <a className={index === 0 ? styles.first : null} href={item.url} target="_blank" rel={relText}>
                        {item.title}
                    </a>
                </li>
            );
        });
    }
    render() {
        return <div className={classNames(styles.nav2, 'clearfix')}>{this.navListView(this.props.content)}</div>;
    }
}

class Nav extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { topnav1, topnav2 } = this.props.content;

        return (
            <div className={styles.nav}>
                <Chip id="45006" type="struct" title="导航1" groupName="导航" content={topnav1}>
                    <Nav1 />
                </Chip>
                <Chip id="45007" type="struct" title="导航2" groupName="导航" content={topnav2}>
                    <Nav2 />
                </Chip>
                <dl className={styles.kehuduan}>
                    <dt className={styles.kehuduanImg}>
                        <img src={require('./kehuduan.jpg')} />
                    </dt>
                    <dd className={styles.mobile}>
                        <img src={require('./mobile2.png')} />
                    </dd>
                </dl>
            </div>
        );
    }
}

export default Nav;
